import { render, staticRenderFns } from "./feedback-column.vue?vue&type=template&id=fdabf706"
import script from "./feedback-column.vue?vue&type=script&lang=js"
export * from "./feedback-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports